import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    badges: {} as {[k: string]: number | undefined}
}

const navBadgesSlice = createSlice({
    name: 'navBadges',
    initialState,
    reducers: {
        setNavBadge: (state, action) => {
            const { path, val } = action.payload
            state.badges[path] = val
        },
    }
})

export const { setNavBadge } = navBadgesSlice.actions
export default navBadgesSlice.reducer
